import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-online-treatment-opinion-of-cancer-experts',
  templateUrl: './online-treatment-opinion-of-cancer-experts.component.html',
  styleUrls: ['./online-treatment-opinion-of-cancer-experts.component.css']
})
export class OnlineTreatmentOpinionOfCancerExpertsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    document.documentElement.scrollTop = 0;
  }

}
